import React, { useEffect, useRef } from 'react';

function QotdSuccessDonut({ d3, counts }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!d3 || !containerRef.current || !counts) return;

    const { success, fail } = counts;
    const donutData = [
      { label: 'Success', value: success },
      { label: 'Fail', value: fail },
    ];

    const container = containerRef.current;
    container.innerHTML = '';

    const cw = container.clientWidth || 400;
    const ch = container.clientHeight || cw;
    const width = cw;
    const height = ch;
    const margin = 10;
    const radius = Math.min(width, height) / 2 - margin;

    const svg = d3
      .select(container)
      .append('svg')
      .attr('viewBox', `0 0 ${width} ${height}`)
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .style('width', '100%')
      .style('height', '100%')
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const color = d3
      .scaleOrdinal()
      .domain(donutData.map((d) => d.label))
      .range(['#96e6ab', '#df87a8']);

    const pie = d3.pie().value((d) => d.value).padAngle(0.02);
    const arcData = pie(donutData);
    const arc = d3.arc().innerRadius(60).outerRadius(radius);

    svg
      .selectAll('path')
      .data(arcData)
      .join('path')
      .attr('d', arc)
      .attr('fill', (d) => color(d.data.label))
      .attr('stroke', 'white')
      .style('stroke-width', '2px');

    const labelArc = d3.arc().innerRadius(radius * 0.5).outerRadius(radius * 0.8);
    const smallAngleThreshold = 0.35; // ~20 degrees
    const outsideOffset = 16; // pixels beyond outer radius

    const labels = svg
      .selectAll('text.qotd-label')
      .data(arcData)
      .join('text')
      .attr('class', 'qotd-label')
      .style('font-size', '16px')
      .style('fill', '#444');

    labels
      .attr('transform', (d) => {
        const angle = d.endAngle - d.startAngle;
        const mid = (d.startAngle + d.endAngle) / 2;
        if (angle < smallAngleThreshold || radius < 80) {
          const x = Math.cos(mid) * (radius + outsideOffset);
          const y = Math.sin(mid) * (radius + outsideOffset);
          return `translate(${x}, ${y})`;
        }
        return `translate(${labelArc.centroid(d)})`;
      })
      .style('text-anchor', (d) => {
        const angle = d.endAngle - d.startAngle;
        const mid = (d.startAngle + d.endAngle) / 2;
        if (angle < smallAngleThreshold || radius < 80) {
          return Math.cos(mid) >= 0 ? 'start' : 'end';
        }
        return 'middle';
      })
      .text((d) => `${d.data.label} (${d.data.value})`);
  }, [d3, counts]);

  return (
    <div className="chart-card svgfix">
      <h2>QUESTION OF THE DAY SUCCESS</h2>
      <div ref={containerRef} />
    </div>
  );
}

export default QotdSuccessDonut;
